import React, { FC } from 'react';

import { Box, Theme, styled, useTheme } from '@material-ui/core';
import { Resizable as ExtResizable } from 're-resizable';

import { Icons, SvgIcon } from './SvgIcon';

const MIN_BLOCK_HEIGHT = 250;

const Line = styled('div')<Theme, { color: string }>(({ theme, color }) => ({
  flex: 1,
  borderBottom: theme.config.defaultBorder(color),
  '&:first-child': {
    marginRight: theme.spacing(1),
  },
  '&:last-child': {
    marginLeft: '1rem',
  },
}));

const ResizableWrapper = styled('div')<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  width: '100%',
  overflow: 'hidden',
}));

const ResizableContent = styled('div')<Theme>(({ theme }) => ({
  width: '100%',
  paddingBottom: theme.spacing(3),
}));

const StyledHandle = styled(Box)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(-1),
  padding: theme.spacing(1),
  background: theme.palette.common.white,
}));

const Resizable = styled(ExtResizable)<Theme>(({ theme }) => ({
  paddingBottom: theme.spacing(1),
}));

const BottomDragHandle = () => {
  const theme = useTheme();
  const color = theme.palette.grey['900'];

  return (
    <StyledHandle width="100%" display="flex" justifyContent="center" alignItems="center">
      <Line color={color} />
      <SvgIcon color={color} icon={Icons.DRAGGABLE} />
      <Line color={color} />
    </StyledHandle>
  );
};

type Props = { height: number; onHeightChange: (value: number) => void };
const BlockResize: FC<Props> = ({ height, onHeightChange, children }) => (
  <ResizableWrapper>
    <ResizableContent>
      <Resizable
        size={{ width: '100%', height: height + 10 }}
        onResizeStop={(e, dir, ref, d) => onHeightChange(height + d.height)}
        minHeight={MIN_BLOCK_HEIGHT}
        handleComponent={{ bottom: <BottomDragHandle /> }}
      >
        {children}
      </Resizable>
    </ResizableContent>
  </ResizableWrapper>
);

export default BlockResize;
